import { Platform, DeviceInfoDefaults } from '../deviceInfoTypes';

export function getPlatform(ua: NavigatorID['userAgent']): Platform {
  const platform = {
    ...DeviceInfoDefaults.platform,
    IS_IOS: /iPad|iPhone|iPod/.test(ua),
    IS_ANDROID_OS: /Android/.test(ua),
    IS_DESKTOP: !(/iPad|iPhone|iPod/.test(ua) || /Android/.test(ua)),
  };

  return platform;
}
